/**
 * @flow
 * @relayHash 94b60e629e32ce60146bf06efbbfd5db
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateSettingsInput = {|
  adminEmails: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type settingsUpdateSettingsMutationVariables = {|
  input: UpdateSettingsInput
|};
export type settingsUpdateSettingsMutationResponse = {|
  +updateSettings: ?{|
    +settings: {|
      +adminEmails: ?$ReadOnlyArray<?string>
    |}
  |}
|};
export type settingsUpdateSettingsMutation = {|
  variables: settingsUpdateSettingsMutationVariables,
  response: settingsUpdateSettingsMutationResponse,
|};
*/


/*
mutation settingsUpdateSettingsMutation(
  $input: UpdateSettingsInput!
) {
  updateSettings(input: $input) {
    settings {
      adminEmails
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateSettingsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateSettings",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSettingsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "settings",
        "storageKey": null,
        "args": null,
        "concreteType": "Settings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "adminEmails",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "settingsUpdateSettingsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "settingsUpdateSettingsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "settingsUpdateSettingsMutation",
    "id": null,
    "text": "mutation settingsUpdateSettingsMutation(\n  $input: UpdateSettingsInput!\n) {\n  updateSettings(input: $input) {\n    settings {\n      adminEmails\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a7790f4e6ae939564b78636628f6b41b';
module.exports = node;
